import ScalingInput from './ScalingInput'

export default ScalingInput
